import { Shipment } from "../../../services/prePlanningService.types";
import { defaultMockServiceCenter } from "../../serviceCenter/serviceCenters.mocks";

export const mockShipmentIds: number[] = [
  131365190, 131367485, 131364476, 131363799, 131364100, 131364941, 131365260,
  131356018, 131363858, 131363911, 131364465, 131999001, 131999002, 131999003,
];

export const mockUnassignedShipmentIds: number[] = [131364941];

export const mockPlannedShipmentsDetails = {
  default: [
    {
      id: 131367485,
      tripNumber: "1353104",
      proNumber: "137844650",
      routeId: 30055,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 1383322,
        name: "MAXLINER USA",
      },
      consignee: {
        id: 1301611,
        name: "T3 LINING SUPPLY",
        address: "17605 FABRICA WAY STE B",
        city: "CERRITOS",
        state: "CA",
        zipCode: "90703",
      },
      weight: 490,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
        {
          id: 2,
          name: "LCCC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
        {
          id: 3,
          name: "LCCC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 1,
      etaDate: new Date(),
      deliveryEtaUtc: new Date(new Date().getTime() + 2 * 60 * 60 * 1000),
      lat: 33.87113,
      lng: -118.03215,
      assignment: "CERRITOS-1",
      isManualAssign: false,
      presetRouteName: "CERRITOS",
      presetRouteId: 169,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: "delivery_route",
      isCommitted: false,
      serviceLevel: "MXUS-LTL",
      careOfDelivery: {
        id: 200231,
        name: "T3 LINING SUPPLY",
        address: "17605 FABRICA WAY STE B",
        city: "CERRITOS",
        state: "CA",
        zipCode: "90703",
      },
    },
    {
      id: 131365190,
      tripNumber: "1353104",
      proNumber: "137844361",
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 957992,
        name: "AMERICAN BOTANICALS",
      },
      consignee: {
        id: 184745,
        name: "ESMOND NATURAL",
        address: "5316 IRWINDALE AVE",
        city: "IRWINDALE",
        state: "CA",
        zipCode: "91706",
      },
      weight: 970,
      isPlanned: true,
      futurePlanDates: [20250210],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 2,
      etaDate: new Date(),
      deliveryEtaUtc: new Date("2025-08-28T15:13:00.000Z"),
      lat: 34.10957,
      lng: -117.93137,
      assignment: "AZUSA-1",
      isManualAssign: false,
      presetRouteName: "AZUSA",
      presetRouteId: 177,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
      locationDetails: {
        id: 3166097,
        type: "trip",
        name: "Trip-31365190",
        location: "DYLT185719",
        status: "ARIV",
      },
    },
    {
      id: 136665190,
      tripNumber: "1353104",
      proNumber: "137666361",
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 957992,
        name: "AMERICAN BOTANICALS",
      },
      consignee: {
        id: 184745,
        name: "ESMOND NATURAL",
        address: "5316 IRWINDALE AVE",
        city: "IRWINDALE",
        state: "CA",
        zipCode: "91706",
      },
      weight: 970,
      isPlanned: true,
      futurePlanDates: [20250210],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 2,
      etaDate: new Date(),
      deliveryEtaUtc: new Date("2025-08-28T15:13:00.000Z"),
      lat: 34.10957,
      lng: -117.93137,
      assignment: "AZUSA-1",
      isManualAssign: false,
      presetRouteName: "AZUSA",
      presetRouteId: 177,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
      locationDetails: {
        id: 3166097,
        type: "trip",
        name: "Trip-31365190",
        location: "DYLT185719",
        status: "ARIV",
      },
    },
    {
      id: 141365190,
      tripNumber: "1353104",
      proNumber: "147844361",
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 957992,
        name: "AMERICAN BOTANICALS",
      },
      consignee: {
        id: 184745,
        name: "ESMOND NATURAL",
        address: "5316 IRWINDALE AVE",
        city: "IRWINDALE",
        state: "CA",
        zipCode: "91706",
      },
      weight: 970,
      isPlanned: true,
      futurePlanDates: [20250210],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 2,
      etaDate: new Date(),
      deliveryEtaUtc: new Date("2025-08-28T15:13:00.000Z"),
      lat: 34.10957,
      lng: -117.93137,
      assignment: "BURBANK-1",
      isManualAssign: false,
      presetRouteName: "BURBANK",
      presetRouteId: 177,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
      locationDetails: {
        id: 3166097,
        type: "trip",
        name: "Trip-31365190",
        location: "DYLT185719",
        status: "ARIV",
      },
    },
    {
      id: 151365190,
      tripNumber: "1353104",
      proNumber: "157844361",
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 957992,
        name: "AMERICAN BOTANICALS",
      },
      consignee: {
        id: 184745,
        name: "ESMOND NATURAL",
        address: "5316 IRWINDALE AVE",
        city: "IRWINDALE",
        state: "CA",
        zipCode: "91706",
      },
      weight: 970,
      isPlanned: true,
      futurePlanDates: [20250210],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 2,
      etaDate: new Date(),
      deliveryEtaUtc: new Date("2025-08-28T15:13:00.000Z"),
      lat: 34.10957,
      lng: -117.93137,
      assignment: "MIRA LOMA-1",
      isManualAssign: false,
      presetRouteName: "MIRA LOMA",
      presetRouteId: 177,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
      locationDetails: {
        id: 3166097,
        type: "trip",
        name: "Trip-31365190",
        location: "DYLT185719",
        status: "ARIV",
      },
    },
    {
      id: 131365890,
      tripNumber: "1353104",
      proNumber: "127845861",
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 957992,
        name: "AMERICAN BOTANICALS",
      },
      consignee: {
        id: 184745,
        name: "ESMOND NATURAL",
        address: "5316 IRWINDALE AVE",
        city: "IRWINDALE",
        state: "CA",
        zipCode: "91706",
      },
      weight: 970,
      isPlanned: true,
      futurePlanDates: [20250210],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 1,
      etaDate: new Date(),
      deliveryEtaUtc: new Date("2025-08-28T15:13:00.000Z"),
      lat: 34.10957,
      lng: -117.93137,
      assignment: "DEACTIVATED DRIVER EQUIPMENT",
      isManualAssign: false,
      presetRouteName: "DEACTIVATED DRIVER EQUIPMENT",
      presetRouteId: 177,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
      locationDetails: {
        id: 3166097,
        type: "trip",
        name: "Trip-31365190",
        location: "DYLT185719",
        status: "ARIV",
      },
    },
    {
      id: 131365490,
      tripNumber: "1353104",
      proNumber: "137844462",
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 957992,
        name: "AMERICAN BOTANICALS",
      },
      consignee: {
        id: 184745,
        name: "ESMOND NATURAL",
        address: "5316 IRWINDALE AVE",
        city: "IRWINDALE",
        state: "CA",
        zipCode: "91706",
      },
      weight: 970,
      isPlanned: true,
      futurePlanDates: [20250210],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 2,
      etaDate: new Date(),
      deliveryEtaUtc: new Date("2025-08-28T15:13:00.000Z"),
      lat: 34.10957,
      lng: -117.93137,
      assignment: "BURBANK-2",
      isManualAssign: false,
      presetRouteName: "BURBANK",
      presetRouteId: 177,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
      locationDetails: {
        id: 3166097,
        type: "trip",
        name: "Trip-31365190",
        location: "DYLT185719",
        status: "ARIV",
      },
    },
    {
      id: 131165170,
      tripNumber: "1353188",
      proNumber: "137844362",
      routeId: null,
      pallets: 2,
      pieces: 4,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 957992,
        name: "AMERICAN BOTANICALS",
      },
      consignee: {
        id: 184745,
        name: "ESMOND NATURAL",
        address: "5316 IRWINDALE AVE",
        city: "IRWINDALE",
        state: "CA",
        zipCode: "91706",
      },
      weight: 1233,
      isPlanned: true,
      futurePlanDates: [20250210],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 2,
      etaDate: new Date(),
      deliveryEtaUtc: new Date("2025-08-29T15:13:00.000Z"),
      lat: 34.10957,
      lng: -117.93137,
      assignment: "AZUSA-3",
      isManualAssign: false,
      presetRouteName: "AZUSA",
      presetRouteId: 177,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
      locationDetails: {
        id: 3166097,
        type: "trip",
        name: "Trip-31365190",
        location: "DYLT185719",
        status: "ARIV",
      },
    },
    {
      id: 131165122,
      tripNumber: "1353108",
      proNumber: "137844422",
      routeId: null,
      pallets: 2,
      pieces: 4,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "DLVR",
      shipper: {
        id: 957992,
        name: "AMERICAN BOTANICALS",
      },
      consignee: {
        id: 184745,
        name: "ESMOND NATURAL",
        address: "5316 IRWINDALE AVE",
        city: "IRWINDALE",
        state: "CA",
        zipCode: "91706",
      },
      weight: 1233,
      isPlanned: true,
      futurePlanDates: [20250210],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 2,
      etaDate: new Date(),
      deliveryEtaUtc: new Date("2025-08-29T15:23:00.000Z"),
      lat: 34.10957,
      lng: -117.93137,
      assignment: "AZUSA-3",
      isManualAssign: false,
      presetRouteName: "AZUSA",
      presetRouteId: 177,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
      locationDetails: {
        id: 3166097,
        type: "trip",
        name: "Trip-31365190",
        location: "DYLT185719",
        status: "ARIV",
      },
    },
    {
      id: 131365191,
      tripNumber: "1353104",
      proNumber: "137844332",
      deliveryEtaUtc: new Date(new Date().getTime() + 4 * 60 * 60 * 1000),
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "DLVR",
      shipper: {
        id: 957992,
        name: "AMERICAN BOTANICALS",
      },
      consignee: {
        id: 184745,
        name: "ESMOND NATURAL",
        address: "5316 IRWINDALE AVE",
        city: "IRWINDALE",
        state: "CA",
        zipCode: "91706",
      },
      delivery: {
        id: 184746,
        name: "ESMOND NATURAL",
        address: "5322 IRWIN AVE",
        city: "IRWIN",
        state: "CA",
        zipCode: "91706",
      },
      weight: 970,
      isPlanned: true,
      futurePlanDates: [20250210],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 1,
      etaDate: new Date(),
      lat: 34.10957,
      lng: -117.93137,
      assignment: "AZUSA-1",
      isManualAssign: false,
      presetRouteName: "AZUSA",
      presetRouteId: 177,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
    },
    {
      id: 131364477,
      tripNumber: "1353106",
      proNumber: "131364477",
      deliveryEtaUtc: new Date(new Date().getTime() + 4 * 60 * 60 * 1000),
      routeId: 30058,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 957992,
        name: "AMERICAN BOTANICALS",
      },
      consignee: {
        id: 184745,
        name: "ESMOND NATURAL",
        address: "5316 IRWINDALE AVE",
        city: "IRWINDALE",
        state: "CA",
        zipCode: "91706",
      },
      weight: 970,
      isPlanned: true,
      futurePlanDates: [],
      tags: [],
      highlightedRow: true,
      stopSeq: 1,
      etaDate: new Date(),
      lat: 34.14415,
      lng: -117.88136,
      assignment: "CERRITOS-1",
      isManualAssign: false,
      presetRouteName: "CERRITOS",
      presetRouteId: 177,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: "delivery_route",
      isCommitted: false,
    },
    {
      id: 131364476,
      tripNumber: "1353104",
      proNumber: "137844452",
      deliveryEtaUtc: new Date(new Date().getTime() + 4 * 60 * 60 * 1000),
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 32766,
        name: "MARINE OIL SVCS",
      },
      consignee: {
        id: 370649,
        name: "BAE SYSTEMS SAN DIEGO",
        address: "1650 INDUSTRIAL BLVD",
        city: "CHULA VISTA",
        state: "CA",
        zipCode: "91911",
      },
      weight: 625,
      isPlanned: true,
      futurePlanDates: [],
      tags: [],
      highlightedRow: true,
      stopSeq: 1,
      etaDate: new Date(),
      lat: 32.59705,
      lng: -117.085,
      assignment: "CHULA VISTA-1",
      isManualAssign: false,
      presetRouteName: "CHULA VISTA",
      presetRouteId: 190,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
    },
    {
      id: 131364100,
      tripNumber: "1353104",
      proNumber: "137844825",
      deliveryEtaUtc: new Date(new Date().getTime() + 4 * 60 * 60 * 1000),
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      serviceDueDate: new Date(),
      destinationSicCode: "SFO",
      location: "42943",
      sic: "SFO",
      status: "ARIV",
      shipper: {
        id: 884237,
        name: "AGI",
      },
      consignee: {
        id: 642426,
        name: "TRACY SIGNS ",
        address: "3771 W 11TH ST ",
        city: "TRACY ",
        state: "CA",
        zipCode: "95304",
      },
      weight: 246,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 4,
          name: "APTR",
          description: "Appointment Required ",
          colorHex: "#777DE9",
          position: 110,
        },
      ],
      highlightedRow: true,
      stopSeq: null,
      etaDate: new Date(),
      lat: null,
      lng: null,
      assignment: "SFO",
      isManualAssign: false,
      presetRouteName: "SFO",
      presetRouteId: 342,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
    },
    {
      id: 131363858,
      tripNumber: "1353104",
      proNumber: "137844601",
      deliveryEtaUtc: new Date(new Date().getTime() + 4 * 60 * 60 * 1000),
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      location: "42943",
      sic: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 835460,
        name: "INTERSURGICAL",
      },
      consignee: {
        id: 596319,
        name: "MEDLINE INDUSTRIES ",
        address: "1960 W MIRO WAY",
        city: "RIALTO",
        state: "CA",
        zipCode: "92376",
      },
      weight: 366,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 4,
          name: "APTR",
          description: "Appointment Required ",
          colorHex: "#777DE9",
          position: 110,
        },
      ],
      highlightedRow: true,
      stopSeq: null,
      etaDate: new Date(),
      lat: null,
      lng: null,
      assignment: "Trap-APPT-APTR",
      isManualAssign: false,
      presetRouteName: "FONTANA",
      presetRouteId: 160,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
    },
    {
      id: 131356018,
      tripNumber: "1353104",
      proNumber: "137844932",
      deliveryEtaUtc: new Date(new Date().getTime() + 4 * 60 * 60 * 1000),
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      location: "42943",
      sic: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 815873,
        name: "NAVIEN INC",
      },
      consignee: {
        id: 542891,
        name: "HIRSCH PIPE & SUPPLY CORP",
        address: "910 E SANDHILL AVE",
        city: "CARSON",
        state: "CA",
        zipCode: "90746",
      },
      weight: 844,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 4,
          name: "APTR",
          description: "Appointment Required ",
          colorHex: "#777DE9",
          position: 110,
        },
      ],
      highlightedRow: true,
      stopSeq: null,
      etaDate: new Date(),
      lat: null,
      lng: null,
      assignment: "Trap-APPT-APTR",
      isManualAssign: false,
      presetRouteName: "CARSON",
      presetRouteId: 192,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
    },
    {
      id: 131363911,
      tripNumber: "1353104",
      proNumber: "137844684",
      deliveryEtaUtc: new Date(new Date().getTime() + 4 * 60 * 60 * 1000),
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      location: "42943",
      sic: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 2292688,
        name: "HIGH TOWER GROUP",
      },
      consignee: {
        id: 1215023,
        name: "ENVIRONMENTS PLUS",
        address: "13707 MARQUARDT AVE",
        city: "SANTA FE SPGS",
        state: "CA",
        zipCode: "90670",
      },
      weight: 253,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 4,
          name: "APTR",
          description: "Appointment Required ",
          colorHex: "#777DE9",
          position: 110,
        },
      ],
      highlightedRow: true,
      stopSeq: null,
      etaDate: new Date(),
      lat: null,
      lng: null,
      assignment: "Trap-APPT-APTR",
      isManualAssign: false,
      presetRouteName: "SANTA FE SPRINGS",
      presetRouteId: 209,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
    },
    {
      id: 131363799,
      tripNumber: "1353104",
      proNumber: "137844692",
      deliveryEtaUtc: new Date(new Date().getTime() + 4 * 60 * 60 * 1000),
      routeId: null,
      pallets: 2,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      serviceDueDate: new Date(),
      destinationSicCode: "SFO",
      location: "42943",
      sic: "SFO",
      status: "ARIV",
      shipper: {
        id: 2292688,
        name: "HIGH TOWER GROUP",
      },
      consignee: {
        id: 3717779,
        name: "TURNER CONSTRUCTION COMPANY",
        address: "100 BUSH ST STE 501",
        city: "SAN FRANCISCO",
        state: "CA",
        zipCode: "94104",
      },
      weight: 300,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 4,
          name: "APTR",
          description: "Appointment Required ",
          colorHex: "#777DE9",
          position: 110,
        },
      ],
      highlightedRow: true,
      stopSeq: null,
      etaDate: new Date(),
      lat: null,
      lng: null,
      assignment: "SFO",
      isManualAssign: false,
      presetRouteName: "SFO",
      presetRouteId: 342,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
    },
    {
      id: 131365260,
      tripNumber: "1353104",
      proNumber: "137844387",
      deliveryEtaUtc: new Date(new Date().getTime() + 4 * 60 * 60 * 1000),
      routeId: null,
      pallets: 2,
      pieces: 2,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      serviceDueDate: new Date(),
      destinationSicCode: "SFO",
      location: "42943",
      sic: "SFO",
      status: "ARIV",
      shipper: {
        id: 86690,
        name: "ROSENBURG USA",
      },
      consignee: {
        id: 166715,
        name: "CELLAR PRO",
        address: "1445 N MCDOWELL BLVD",
        city: "PETALUMA",
        state: "CA",
        zipCode: "94954",
      },
      weight: 1110,
      isPlanned: true,
      futurePlanDates: [],
      tags: [],
      highlightedRow: true,
      stopSeq: null,
      etaDate: new Date(),
      lat: null,
      lng: null,
      assignment: "SFO",
      isManualAssign: false,
      presetRouteName: "SFO",
      presetRouteId: 342,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
    },
    {
      id: 131364465,
      tripNumber: "1353104",
      proNumber: "137844916",
      deliveryEtaUtc: new Date(new Date().getTime() + 4 * 60 * 60 * 1000),
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      serviceDueDate: new Date(),
      destinationSicCode: "VIS",
      location: "42943",
      sic: "VIS",
      status: "ARIV",
      shipper: {
        id: 884237,
        name: "AGI",
      },
      consignee: {
        id: 197243,
        name: "PROLITE SIGNS",
        address: "12645 HANFORD-ARMONA RD",
        city: "HANFORD",
        state: "CA",
        zipCode: "93230",
      },
      weight: 242,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 4,
          name: "APTR",
          description: "Appointment Required ",
          colorHex: "#777DE9",
          position: 110,
        },
      ],
      highlightedRow: true,
      stopSeq: null,
      etaDate: new Date(),
      lat: null,
      lng: null,
      assignment: "VIS",
      isManualAssign: false,
      presetRouteName: "VIS",
      presetRouteId: 341,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
    },
    {
      id: 131364941,
      tripNumber: "1353104",
      proNumber: "137844619",
      deliveryEtaUtc: new Date(new Date().getTime() + 4 * 60 * 60 * 1000),
      routeId: null,
      pallets: 2,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      location: "42943",
      sic: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 1210869,
        name: "BOSCH REXROTH",
      },
      consignee: {
        id: 190452,
        name: "VALLEY FABRICATION",
        address: "1056 PELLET AVE",
        city: "SALINAS",
        state: "CA",
        zipCode: "93901",
      },
      weight: 2280,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 9,
          name: "DTCL",
          description: "Delivery to Connecting Line",
          colorHex: "#5E9FE0",
          position: 170,
        },
      ],
      highlightedRow: true,
      stopSeq: null,
      etaDate: new Date(),
      lat: null,
      lng: null,
      assignment: "SFO",
      isManualAssign: false,
      presetRouteName: "SFO",
      presetRouteId: 342,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
    },
    {
      id: 135140213,
      tripNumber: "3177199",
      proNumber: "156043937",
      routeId: 334149,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "ENG42906",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARIV",
      shipper: {
        id: 30361345,
        name: "KURIYAMA OF AMERICA INC",
      },
      consignee: {
        id: 29676714,
        name: "DELAFIELD CORP",
        address: "1520 FLOWER AVE",
        city: "DUARTE",
        state: "CA",
        zipCode: "91010",
      },
      weight: 225,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 1,
          name: "ST",
          description: "Straight Truck",
          colorHex: "#7a9aad",
          position: "220",
        },
      ],
      highlightedRow: true,
      stopSeq: 1,
      etaDate: new Date(),
      deliveryEtaUtc: new Date(new Date().getTime() + 2 * 60 * 60 * 1000),
      lat: 34.13433,
      lng: -117.96201,
      assignment: "EL MONTE-1",
      isManualAssign: false,
      presetRouteName: "EL MONTE",
      presetRouteId: 549,
      isAvailableToReconcile: true,
      assignmentId: 334149,
      type: "delivery_route",
      isCommitted: false,
    },
    {
      id: 131999001,
      tripNumber: "1353999",
      proNumber: "139999001",
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ARCS",
      shipper: {
        id: 1383322,
        name: "MAXLINER USA",
      },
      consignee: {
        id: 1301611,
        name: "T3 LINING SUPPLY",
        address: "17605 FABRICA WAY STE B",
        city: "CERRITOS",
        state: "CA",
        zipCode: "90703",
      },
      weight: 490,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 1,
      etaDate: new Date(),
      deliveryEtaUtc: new Date(new Date().getTime() + 2 * 60 * 60 * 1000),
      lat: 33.87113,
      lng: -118.03215,
      assignment: "ANAHEIM-2",
      isManualAssign: false,
      presetRouteName: "ANAHEIM",
      presetRouteId: 169,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
      serviceLevel: "MXUS-LTL",
      careOfDelivery: {
        id: 200231,
        name: "T3 LINING SUPPLY",
        address: "17605 FABRICA WAY STE B",
        city: "CERRITOS",
        state: "CA",
        zipCode: "90703",
      },
    },
    {
      id: 131999002,
      tripNumber: "1353998",
      proNumber: "139999002",
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "ATMP",
      shipper: {
        id: 1383322,
        name: "MAXLINER USA",
      },
      consignee: {
        id: 1301611,
        name: "T3 LINING SUPPLY",
        address: "17605 FABRICA WAY STE B",
        city: "CERRITOS",
        state: "CA",
        zipCode: "90703",
      },
      weight: 490,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 1,
      etaDate: new Date(),
      deliveryEtaUtc: new Date(new Date().getTime() + 2 * 60 * 60 * 1000),
      lat: 33.87113,
      lng: -118.03215,
      assignment: "ANAHEIM-3",
      isManualAssign: false,
      presetRouteName: "ANAHEIM",
      presetRouteId: 169,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
      serviceLevel: "MXUS-LTL",
      careOfDelivery: {
        id: 200231,
        name: "T3 LINING SUPPLY",
        address: "17605 FABRICA WAY STE B",
        city: "CERRITOS",
        state: "CA",
        zipCode: "90703",
      },
    },
    {
      id: 131999003,
      tripNumber: "1353997",
      proNumber: "139999003",
      routeId: null,
      pallets: 1,
      pieces: 0,
      weightUnit: "lbs",
      appointmentDate: null,
      appointmentEndDate: null,
      serviceDue: new Date(),
      location: "42943",
      sic: defaultMockServiceCenter.code,
      serviceDueDate: new Date(),
      destinationSicCode: defaultMockServiceCenter.code,
      status: "RTRN",
      shipper: {
        id: 1383322,
        name: "MAXLINER USA",
      },
      consignee: {
        id: 1301611,
        name: "T3 LINING SUPPLY",
        address: "17605 FABRICA WAY STE B",
        city: "CERRITOS",
        state: "CA",
        zipCode: "90703",
      },
      weight: 490,
      isPlanned: true,
      futurePlanDates: [],
      tags: [
        {
          id: 1,
          name: "CC",
          description: "Critical Care",
          colorHex: "#DB6561",
          position: "1",
        },
      ],
      highlightedRow: true,
      stopSeq: 1,
      etaDate: new Date(),
      deliveryEtaUtc: new Date(new Date().getTime() + 2 * 60 * 60 * 1000),
      lat: 33.87113,
      lng: -118.03215,
      assignment: "ANAHEIM-4",
      isManualAssign: false,
      presetRouteName: "ANAHEIM",
      presetRouteId: 169,
      isAvailableToReconcile: true,
      assignmentId: null,
      type: null,
      isCommitted: false,
      serviceLevel: "MXUS-LTL",
      careOfDelivery: {
        id: 200231,
        name: "T3 LINING SUPPLY",
        address: "17605 FABRICA WAY STE B",
        city: "CERRITOS",
        state: "CA",
        zipCode: "90703",
      },
    },
  ],
} as const satisfies Record<string, Shipment[]>;

export const makeShipmentMock = (
  overrides: Partial<Shipment> = {}
): Shipment => ({
  ...mockPlannedShipmentsDetails.default[0],
  ...overrides,
});
